<template>
  <UiTableWithPagination
    height="600px"
    table-class="outcome-products-table"
    hide-pagination
    :data="props.items">
    <ElTableColumn prop="product.title" :label="$t('Nomenclature.NameOfProduct')" />
    <ElTableColumn prop="product.article" :label="$t('Nomenclature.VendorCode')" width="150px" />
    <ElTableColumn prop="count" :label="$t('Nomenclature.Qty')" width="200px" />
    <ElTableColumn prop="actions">
      <template #default="{ row }">
        <div class="outcome-products-table-actions">
          <ElButton
            class="outcome-products-table-actions__delete-button"
            type="primary"
            text
            @click.stop="$emit('table:delete', row.product_id)">
            <template #icon>
              <MiIcon icon="CLOSE" />
            </template>
          </ElButton>
        </div>
      </template>
    </ElTableColumn>
  </UiTableWithPagination>
</template>

<script lang="ts">
export default {
  name: 'TransformGoodsTable',
  inheritAttrs: false,
  customOptions: {},
};
</script>

<script lang="ts" setup>
import { OutcomeProductDto } from '@/types/api';
import { MiIcon } from '~shared/ui';

defineEmits(['table:delete']);

const props = defineProps<{ items: OutcomeProductDto[] }>();
</script>

<style lang="scss" src="./index.scss" />
<i18n src="@/locales/base.locales.json" />
<i18n src="@/locales/warehouse.locales.json" />
